import { ActivatedRoute } from '@angular/router';
import type { Router } from '@angular/router';
import { distinctUntilChanged, map, merge, type Observable } from 'rxjs';

export function readRouteNumericParam(
  route: ActivatedRoute,
  paramName: string,
): number {
  for (const segment of route.pathFromRoot) {
    const raw = segment.snapshot.paramMap.get(paramName);
    if (raw == null || raw === '') {
      continue;
    }
    const value = Number(raw);
    if (Number.isFinite(value) && value > 0) {
      return value;
    }
  }
  return 0;
}

export function watchRouteNumericParam(
  route: ActivatedRoute,
  paramName: string,
): Observable<number> {
  const sources = route.pathFromRoot.map((segment) =>
    segment.paramMap.pipe(map(() => readRouteNumericParam(route, paramName))),
  );

  if (sources.length === 0) {
    return merge().pipe(map(() => 0));
  }

  return merge(...sources).pipe(distinctUntilChanged());
}

export function readLaunchpadProjectId(
  route: ActivatedRoute,
  router: Router,
): number {
  const fromRouteTree = readRouteNumericParam(route, 'projectId');
  if (fromRouteTree) {
    return fromRouteTree;
  }

  const match = router.url.match(/\/launchpad\/(\d+)(?:\/|$)/);
  if (!match) {
    return 0;
  }

  const value = Number(match[1]);
  return Number.isFinite(value) && value > 0 ? value : 0;
}

export function watchLaunchpadProjectId(
  route: ActivatedRoute,
  router: Router,
): Observable<number> {
  return watchRouteNumericParam(route, 'projectId').pipe(
    map((fromRouteTree) =>
      fromRouteTree > 0 ? fromRouteTree : readLaunchpadProjectId(route, router),
    ),
    distinctUntilChanged(),
  );
}
